module.exports = __webpack_public_path__ + "img/step_three_en.bfdaa4e5.png";